module.exports = __webpack_public_path__ + "img/caselist35.0472ad8c.jpg";